import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function UpEnergyMonitoring() {
  return (
    <div className="art-page">
      <SEO
        title="Monitoring for Improved Cookstove Carbon Projects — UpEnergy (2011 – Ongoing)"
        description="UpEnergy is one of Uganda's leading clean energy enterprises, operating a portfolio of Gold Standard-registered carbon programmes covering multiple improved cookstove technologies. Since 2011, CIRCODU has served as UpEnergy's independent monitoring organisation — a relationship that has grown from laboratory and field monitoring of household stoves into a comprehensive, multi-programme monitoring partnership that remains active today."
        keywords="UpEnergy, cookstove carbon projects, Gold Standard, carbon programmes, improved cookstoves, monitoring partnership, laboratory testing, field monitoring, Kitchen Performance Tests, WBTs, customer insights study, PoA verification, CIRCODU, UpEnergy monitoring Uganda, cookstove carbon projects Uganda, Gold Standard programmes Uganda, improved cookstoves Uganda, monitoring partnership Uganda, laboratory testing Uganda, field monitoring Uganda, Kitchen Performance Tests Uganda, WBTs Uganda, customer insights study Uganda, PoA verification Uganda"
        url="/Monitoring-for-Improved-Cookstove-Carbon-Projects-UpEnergy-2011-Ongoing"
        datePublished="2026-01-20"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Monitoring for Improved Cookstove Carbon Projects — UpEnergy
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              January 20, 2026
            </div>
            <h1 className="art-title">
              Monitoring for Improved Cookstove Carbon Projects — UpEnergy (2011
              – Ongoing)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                <strong>UpEnergy</strong> is one of Uganda's leading clean
                energy enterprises, operating a portfolio of Gold
                Standard-registered carbon programmes covering multiple improved
                cookstove technologies. Since <strong>2011</strong>, CIRCODU has
                served as UpEnergy's independent monitoring organisation — a
                relationship that has grown from laboratory and field monitoring
                of household stoves into a comprehensive, multi-programme
                monitoring partnership that remains active today.
              </p>
              <h2 className="art-subheading">Progression of the Engagement</h2>
              <ol>
                <li>
                  <strong>
                    2011–2018 — Household Carbon Programme Monitoring:
                  </strong>{" "}
                  Baseline study assessments, kitchen surveys, usage surveys,
                  KPTs, and WBTs on the EZY, Smart Home, AES Envirofit G3300,
                  and Jiko Poa stove models distributed through the programme.
                </li>
                <li>
                  <strong>
                    February 2022 — Thermal Efficiency Laboratory Testing:
                  </strong>{" "}
                  WBTs on field-sampled stoves measuring in-use thermal
                  efficiency to support PoA verification, with formal WBT
                  results report.
                </li>
                <li>
                  <strong>
                    June 2022 — Baseline Study and KPTs in 700 Schools:
                  </strong>{" "}
                  A major expansion into the institutional market — large-scale
                  baseline study and KPTs across 700 schools nationwide to
                  determine cooking practices and willingness to acquire clean
                  cooking technologies.
                </li>
                <li>
                  <strong>
                    June 2022 — Customer Insights Study (Finnfund):
                  </strong>{" "}
                  Commissioned by Finnish Fund for Industrial Cooperation
                  (Finnfund) as investor in UpEnergy — study examining customer
                  experience, satisfaction across customer segments, and social
                  impact of the programme.
                </li>
                <li>
                  <strong>
                    2023–2026 — Ongoing Gold Standard PoA Monitoring:
                  </strong>{" "}
                  Regular WBTs for multiple active Programmes of Activities —
                  PoA #9956/GS, #10898/CDM, #7997/GS, #11191/GS, #10963/GS, and
                  #1044 — following WBT Version 4.2.3, providing verification
                  data for each programme's annual Gold Standard registration
                  cycle, continuing through 2025 with new cycle commencing
                  January 2026.
                </li>
              </ol>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's Gold Standard monitoring
                services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
